export const ForgotPassword = {
	title: "Forgot Password",
	explanation_text: "Enter your email address, and we'll send you instructions to reset your password.",
	button_text: "Send Reset Instructions",
	button_loading_text: "Sending reset instructions...",
	remember_password_text: "Remember your password?",
	login_button_text: "Login",
	success_title: "Reset Instructions Sent!",
	success_explanation_text: `
        If your email exists in our system, you will receive password reset instructions.
        Please check your email and follow the steps.
    `,
};
